<template>
  <v-container>
    <v-data-table
      fixed-header
      :header-props="{ sortIcon: 'fas fa-sort-amount-up-alt' }"
      :headers="headers"
      :items="items"
      :loading="loading"
      sort-by="updated_at"
      :sort-desc="true"
      :items-per-page="itemsPerPage"
      @update:items-per-page="updateRecordsPerPage"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
      :options.sync="options"
      :server-items-length="totalItems"
      :dense="showDense"
      class="elevation-2"
    >
      <template v-slot:top>
        <v-row align="center" class="py-1 px-2" no-gutters>
          <v-col cols="12" sm="6">
            <v-breadcrumbs
              class="px-2"
              :items="breadcrumbsItems"
            ></v-breadcrumbs>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            :class="
              $store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  color="primary"
                  @click.stop="newDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fa-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("new") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  @click.stop="importDialog = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fa-file-import</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("importFromExcel") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  @click.stop="getLines"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>fa-sync</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("refresh") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  @click="showDense = !showDense"
                  v-bind="attrs"
                  v-on="on"
                  :color="showDense ? 'success' : ''"
                >
                  <v-icon small>fas fa-compress-alt</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("compactView") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="mx-2"
                  v-bind="attrs"
                  v-on="on"
                  color="orange"
                  @click="helpDialog = true"
                >
                  <v-icon small>fa-question</v-icon>
                </v-btn>
              </template>
              <span>{{ $vuetify.lang.translator("showHelp") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.index="{ item }">
        {{
          (options.page - 1) * options.itemsPerPage + items.indexOf(item) + 1
        }}
      </template>
      <template v-slot:item.updated_at="{ item }">
        <div class="ltr-text" v-if="$store.getters.LANGUAGE == 'fa'">
          {{ item.updated_at | moment("jYYYY/jM/jD HH:mm") }}
        </div>
        <div class="ltr-text" v-else>
          {{ item.updated_at | moment("YYYY/M/D HH:mm") }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="primary"
              :to="{
                name: 'Towers',
                params: {
                  id: item.id,
                  name: item.name,
                  employer_id: employer_id,
                  employer_name: employer_name
                }
              }"
              v-bind="attrs"
              v-on="on"
              class="mx-1"
            >
              <v-icon small>fas fa-bolt</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.translator("viewTowers") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              @click="downloadKMZ(item.id)"
              :disabled="kmzID == item.id"
              v-bind="attrs"
              v-on="on"
              class="mx-1"
            >
              <span v-if="kmzID == item.id">{{ downloadKmzPercentage }}%</span>
              <v-icon small v-else>fa-globe</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.translator("downloadLineTowersKMZ") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              @click.stop="openMap(item.id, item.name, item.voltage_level)"
              v-bind="attrs"
              v-on="on"
              class="mx-1"
            >
              <v-icon small>fas fa-map-marked-alt</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.translator("viewTowersOnMap") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              @click.stop="openEdit(item.id, item.name)"
              v-bind="attrs"
              v-on="on"
              class="mx-1"
            >
              <v-icon small>fa-edit</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.translator("edit") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="error"
              @click.stop="
                confirmDelete(
                  item.id,
                  item.name,
                  item.towers_count,
                  item.batches_count
                )
              "
              v-bind="attrs"
              v-on="on"
              class="mx-1"
            >
              <v-icon small>fa-trash</v-icon>
            </v-btn>
          </template>
          <span>{{ $vuetify.lang.translator("delete") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog
      v-model="newDialog"
      persistent
      @keydown.esc="closeNew"
      max-width="640"
    >
      <v-card>
        <v-form ref="newForm" v-model="newValid" @submit.prevent="tryCreate">
          <v-card-title>
            <span class="headline">{{
              $vuetify.lang.translator("createNewLineFor", employer_name)
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.name"
                  :rules="nameRules"
                  :label="$vuetify.lang.translator('name') + ' *'"
                  type="text"
                  autocomplete="on"
                  autofocus
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.code"
                  :rules="fiftyRules"
                  :label="$vuetify.lang.translator('code') + ' *'"
                  type="text"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.origin"
                  :rules="fiftyRules"
                  :label="$vuetify.lang.translator('origin') + ' *'"
                  type="text"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.destination"
                  :rules="fiftyRules"
                  :label="$vuetify.lang.translator('destination') + ' *'"
                  type="text"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.one_circut"
                  :label="$vuetify.lang.translator('singleCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.two_circut"
                  :label="$vuetify.lang.translator('dualCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.four_circut"
                  :label="$vuetify.lang.translator('fourCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.six_circut"
                  :label="$vuetify.lang.translator('sixCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.eight_circut"
                  :label="$vuetify.lang.translator('eightCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.voltage_level"
                  :label="$vuetify.lang.translator('voltageLevel')"
                  type="number"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="waitForNew">
              <v-icon class="mx-2">fa-save</v-icon
              >{{ $vuetify.lang.translator("create") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="closeNew">{{
              $vuetify.lang.translator("close")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editDialog"
      persistent
      @keydown.esc="closeEdit"
      max-width="640"
    >
      <v-card>
        <v-form ref="editForm" v-model="editValid" @submit.prevent="tryEdit">
          <v-card-title>
            <span class="headline">{{ dialogTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="editFields.name"
                  :rules="nameRules"
                  :label="$vuetify.lang.translator('name') + ' *'"
                  type="text"
                  autocomplete="on"
                  autofocus
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="editFields.code"
                  :rules="fiftyRules"
                  :label="$vuetify.lang.translator('code') + ' *'"
                  type="text"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="editFields.origin"
                  :rules="fiftyRules"
                  :label="$vuetify.lang.translator('origin') + ' *'"
                  type="text"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="editFields.destination"
                  :rules="fiftyRules"
                  :label="$vuetify.lang.translator('destination') + ' *'"
                  type="text"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editFields.one_circut"
                  :label="$vuetify.lang.translator('singleCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editFields.two_circut"
                  :label="$vuetify.lang.translator('dualCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editFields.four_circut"
                  :label="$vuetify.lang.translator('fourCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editFields.six_circut"
                  :label="$vuetify.lang.translator('sixCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editFields.eight_circut"
                  :label="$vuetify.lang.translator('eightCircuitLength')"
                  type="number"
                  autocomplete="on"
                  clearable
                  :prefix="$store.getters.LANGUAGE == 'fa' ? 'km' : ''"
                  :suffix="$store.getters.LANGUAGE == 'en' ? 'km' : ''"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editFields.voltage_level"
                  :label="$vuetify.lang.translator('voltageLevel')"
                  type="number"
                  autocomplete="on"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <VuePersianDatetimePicker
                  type="datetime"
                  input-class="vpdp-input"
                  :format="
                    $store.getters.LANGUAGE == 'fa'
                      ? 'jYYYY/jMM/jDD HH:mm'
                      : 'YYYY/MM/DD HH:mm'
                  "
                  input-format="YYYY-MM-DDTHH:mm:ssZ"
                  :disabled="true"
                  color="dimgray"
                  :label="$vuetify.lang.translator('createDate')"
                  v-model="created_at"
                ></VuePersianDatetimePicker>
              </v-col>

              <v-col cols="12" md="6">
                <VuePersianDatetimePicker
                  type="datetime"
                  input-class="vpdp-input"
                  :format="
                    $store.getters.LANGUAGE == 'fa'
                      ? 'jYYYY/jMM/jDD HH:mm'
                      : 'YYYY/MM/DD HH:mm'
                  "
                  input-format="YYYY-MM-DDTHH:mm:ssZ"
                  :disabled="true"
                  color="dimgray"
                  :label="$vuetify.lang.translator('updateDate')"
                  v-model="updated_at"
                ></VuePersianDatetimePicker>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="waitForEdit">
              <v-icon class="mx-2">fa-save</v-icon
              >{{ $vuetify.lang.translator("change") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="closeEdit">{{
              $vuetify.lang.translator("close")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="640px"
      @keydown.esc="closeDelete"
      persistent
    >
      <v-card>
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeDelete">{{
            $vuetify.lang.translator("no")
          }}</v-btn>
          <v-btn
            color="error"
            @click="tryDelete"
            :disabled="waitForDelete"
            :loading="waitForDelete"
            >{{ $vuetify.lang.translator("yes") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="mapDialog"
      max-width="800px"
      persistent
      @keydown.esc="mapDialog = false"
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="mapDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div v-bind:style="styleObject">
          <l-map
            ref="myMap"
            :options="mapOptions"
            :zoom="zoom"
            :center="center"
            @ready="updateMap"
          >
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-control-zoom
              position="topleft"
              :zoomInTitle="$vuetify.lang.translator('zoomIn')"
              :zoomOutTitle="$vuetify.lang.translator('zoomOut')"
            ></l-control-zoom>
            <l-control-fullscreen
              position="topleft"
              :options="{
                title: {
                  false: $vuetify.lang.translator('fullscreen'),
                  true: $vuetify.lang.translator('normal')
                }
              }"
            />
            <l-control-scale
              position="bottomleft"
              :imperial="false"
              :metric="true"
            ></l-control-scale>
            <l-marker
              v-for="item in towers"
              :key="item.code"
              :lat-lng="item.position"
            >
              <l-tooltip :options="{ direction: 'center' }" class="vazir-font"
                >{{ item.name }} ({{ item.code }})
                <div v-if="selectedLineBatch != null">
                  {{ $vuetify.lang.translator("normal") }}: {{ item.type1
                  }}<br />{{ $vuetify.lang.translator("warning") }}:
                  {{ item.type2 }}<br />{{
                    $vuetify.lang.translator("critical")
                  }}:
                  {{ item.type3 }}
                </div>
              </l-tooltip>
              <l-icon :icon-anchor="getIconAnchor()">
                <img src="/static/img/transmission-tower.png" />
              </l-icon>
            </l-marker>
            <l-polyline :lat-lngs="latlangs" :color="lineColor"></l-polyline>
            <l-control position="topright">
              <v-select
                :label="$vuetify.lang.translator('history')"
                :items="lineBatchesItems"
                item-value="id"
                :placeholder="$vuetify.lang.translator('selectADate')"
                v-model="selectedLineBatch"
                clearable
                outlined
                dense
                filled
                class="vazir-font"
              >
                <template v-slot:item="{ item }">
                  {{ item.captured_at | moment(getDateFormat()) }}
                </template>
                <template v-slot:selection="{ item }">
                  {{ item.captured_at | moment(getDateFormat()) }}
                </template>
              </v-select>
            </l-control>
          </l-map>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="importDialog"
      persistent
      @keydown.esc="importDialog = false"
      max-width="640"
    >
      <v-card>
        <v-form
          ref="importForm"
          v-model="importValid"
          @submit.prevent="tryImport"
        >
          <v-toolbar dense elevation="2">
            <v-toolbar-title>{{
              $vuetify.lang.translator(
                "importEmployerLinesExcel",
                employer_name
              )
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon @click="importDialog = false">
                <v-icon>fa-times</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-file-input
              v-model="excelFile"
              :rules="fileRules"
              show-size
              class="ltr-text mt-2"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              :label="$vuetify.lang.translator('selectExcelFile') + ' *'"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn href="/static/files/samples/lines.xlsx">
              <v-icon class="mx-2">fa-download</v-icon
              >{{ $vuetify.lang.translator("sampleFile") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :disabled="waitForImport">
              <span class="mx-2" v-if="waitForImport"
                >{{ uploadPercentage }}%</span
              >
              <v-icon class="mx-2" v-else>fa-upload</v-icon
              >{{ $vuetify.lang.translator("send") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="closeImport">{{
              $vuetify.lang.translator("close")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="helpDialog"
      persistent
      max-width="800"
      @keydown.esc="helpDialog = false"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("help")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="helpDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div
            class="mt-6"
            v-html="$vuetify.lang.translator('linesHelp')"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="helpDialog = false">{{
            $vuetify.lang.translator("gotIt")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { required, max, maxFileSize } from "@/helpers/validations";
import { handleError } from "@/helpers/helper";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { latLng, Icon } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LIcon,
  LControlScale,
  LControlZoom,
  LPolyline,
  LControl
} from "vue2-leaflet";
import LControlFullscreen from "vue2-leaflet-fullscreen";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  name: "Lines",
  components: {
    VuePersianDatetimePicker,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    LControlScale,
    LControlZoom,
    LControlFullscreen,
    LPolyline,
    LControl
  },
  data: () => ({
    breadcrumbsItems: [],
    headers: [],
    items: [],
    itemsPerPage: 0,
    options: {},
    totalItems: 0,
    newValid: false,
    editValid: false,
    fields: {
      employer: null,
      name: "",
      origin: "",
      destination: "",
      code: "",
      one_circut: null,
      two_circut: null,
      four_circut: null,
      six_circut: null,
      eight_circut: null,
      voltage_level: null
    },
    editFields: {
      id: null,
      employer: null,
      name: "",
      origin: "",
      destination: "",
      code: "",
      one_circut: null,
      two_circut: null,
      four_circut: null,
      six_circut: null,
      eight_circut: null,
      voltage_level: null
    },
    created_at: null,
    updated_at: null,
    nameRules: [],
    fiftyRules: [],
    requiredRule: [],
    loading: true,
    newDialog: false,
    waitForNew: false,
    deleteDialog: false,
    dialogTitle: "",
    waitForDelete: false,
    idToBeDeleted: 0,
    editDialog: false,
    waitForEdit: false,
    employer_id: 0,
    employer_name: "",
    showDense: true,
    mapDialog: false,
    mapOptions: {
      zoomControl: false,
      zoomSnap: 0.5
    },
    zoom: 14,
    center: latLng(0, 0),
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '<a href="http://virakavir.com" target="_blank">ViraKavir</a> | &copy; <a href="http://osm.org/copyright" target="_blank">OpenStreetMap</a>',
    styleObject: {
      width: "100%",
      height: "400px"
    },
    towers: [],
    latlangs: [],
    helpDialog: false,
    importDialog: false,
    waitForImport: false,
    importValid: false,
    fileRules: [],
    excelFile: null,
    uploadPercentage: 0,
    lineColor: "black",
    lineBatchesItems: [],
    kmzID: 0,
    downloadKmzPercentage: 0,
    waitForLineBatches: false,
    selectedLineBatch: null
  }),
  watch: {
    options: {
      handler() {
        this.getLines();
      }
    },
    showDense: function() {
      this.$store.dispatch("saveShowDense", this.showDense ? "show" : "hide");
    },
    selectedLineBatch: function() {
      this.getBatcheTowersErrors();
    }
  },
  created() {
    this.itemsPerPage = parseInt(this.$store.getters.PERPAGE);
    this.showDense = this.$store.getters.SHOWDENSE === "show";
    this.employer_id = this.$route.params.id;
    this.employer_name = this.$route.params.name;

    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("management")
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("employers"),
      to: { name: "Employers" }
    });
    this.breadcrumbsItems.push({ text: this.employer_name });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("lines")
    });

    this.headers.push({
      text: this.$vuetify.lang.translator("row"),
      value: "index",
      sortable: false,
      align: "center"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("name"),
      value: "name"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("origin"),
      value: "origin"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("destination"),
      value: "destination"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("code"),
      value: "code"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("single"),
      value: "one_circut"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("dual"),
      value: "two_circut"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("four"),
      value: "four_circut"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("six"),
      value: "six_circut"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("eight"),
      value: "eight_circut"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("circuitLength"),
      value: "total_length"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("voltageLevel"),
      value: "voltage_level"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("towers"),
      value: "towers_count",
      sortable: false
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("batches"),
      value: "batches_count",
      sortable: false
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("updateDate"),
      value: "updated_at"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("operations"),
      value: "actions",
      sortable: false,
      align: "center"
    });

    this.checkPrivileges();
  },
  methods: {
    checkPrivileges() {
      let userType = parseInt(this.$store.getters.USERTYPE);
      let allowed_privileges = [1, 2];
      if (allowed_privileges.indexOf(userType) === -1) {
        this.$router.push({ name: "Error403" });
      }
    },
    getLines() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      var parameters = null;
      if (sortBy[0]) {
        parameters = {
          page: page,
          size: itemsPerPage,
          sort: (sortDesc[0] ? "-" : "") + sortBy[0]
        };
      } else {
        parameters = {
          page: page,
          size: itemsPerPage
        };
      }
      var self = this;
      this.$http
        .get("/employer/" + self.employer_id + "/line/", {
          params: parameters
        })
        .then(function(response) {
          self.items = response.data.results;
          self.totalItems = response.data.count;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.loading = false;
        });
    },
    tryCreate() {
      this.fields.code = this.fields.code.toString();
      this.nameRules = [
        required(this.$vuetify.lang.translator("name"), this.$vuetify),
        max(100, this.$vuetify.lang.translator("name"), this.$vuetify)
      ];
      this.fiftyRules = [
        required(this.$vuetify.lang.translator("thisField"), this.$vuetify),
        max(50, this.$vuetify.lang.translator("thisField"), this.$vuetify)
      ];
      this.requiredRule = [
        required(this.$vuetify.lang.translator("thisField"), this.$vuetify)
      ];
      let self = this;
      setTimeout(function() {
        if (self.$refs.newForm.validate()) {
          self.fields.employer = self.employer_id;
          self.fields.one_circut = parseFloat(self.fields.one_circut).toFixed(
            2
          );
          self.fields.two_circut = parseFloat(self.fields.two_circut).toFixed(
            2
          );
          self.fields.four_circut = parseFloat(self.fields.four_circut).toFixed(
            2
          );
          self.fields.six_circut = parseFloat(self.fields.six_circut).toFixed(
            2
          );
          self.fields.eight_circut = parseFloat(
            self.fields.eight_circut
          ).toFixed(2);
          self.waitForNew = true;
          self.$http
            .post("/employer/" + self.employer_id + "/line/", self.fields)
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("newLineCreated"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getLines();
              self.newDialog = false;
              self.resetData();
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForNew = false;
            });
        }
      });
    },
    closeNew() {
      this.resetData();
      this.newDialog = false;
    },
    openEdit(id, name) {
      this.dialogTitle = this.$vuetify.lang.translator("editLine", name);
      var self = this;
      this.$http
        .get("/line/" + id + "/")
        .then(function(response) {
          self.editFields.id = response.data.id;
          self.editFields.employer = response.data.employer;
          self.editFields.name = response.data.name;
          self.editFields.origin = response.data.origin;
          self.editFields.destination = response.data.destination;
          self.editFields.name = response.data.name;
          self.editFields.code = response.data.code;
          self.editFields.one_circut = parseFloat(
            response.data.one_circut
          ).toFixed(2);
          self.editFields.two_circut = parseFloat(
            response.data.two_circut
          ).toFixed(2);
          self.editFields.four_circut = parseFloat(
            response.data.four_circut
          ).toFixed(2);
          self.editFields.six_circut = parseFloat(
            response.data.six_circut
          ).toFixed(2);
          self.editFields.eight_circut = parseFloat(
            response.data.eight_circut
          ).toFixed(2);
          self.editFields.voltage_level = response.data.voltage_level;
          self.created_at = response.data.created_at;
          self.updated_at = response.data.updated_at;
          self.editDialog = true;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    tryEdit() {
      this.editFields.code = this.editFields.code.toString();
      this.nameRules = [
        required(this.$vuetify.lang.translator("name"), this.$vuetify),
        max(100, this.$vuetify.lang.translator("name"), this.$vuetify)
      ];
      this.fiftyRules = [
        required(this.$vuetify.lang.translator("thisField"), this.$vuetify),
        max(50, this.$vuetify.lang.translator("thisField"), this.$vuetify)
      ];
      this.requiredRule = [
        required(this.$vuetify.lang.translator("thisField"), this.$vuetify)
      ];
      let self = this;
      setTimeout(function() {
        if (self.$refs.editForm.validate()) {
          self.editFields.one_circut = parseFloat(
            self.editFields.one_circut
          ).toFixed(2);
          self.editFields.two_circut = parseFloat(
            self.editFields.two_circut
          ).toFixed(2);
          self.editFields.four_circut = parseFloat(
            self.editFields.four_circut
          ).toFixed(2);
          self.editFields.six_circut = parseFloat(
            self.editFields.six_circut
          ).toFixed(2);
          self.editFields.eight_circut = parseFloat(
            self.editFields.eight_circut
          ).toFixed(2);
          self.waitForEdit = true;
          self.$http
            .put("/line/" + self.editFields.id + "/", self.editFields)
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("lineEdited"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getLines();
              self.editDialog = false;
              self.resetData();
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForEdit = false;
            });
        }
      });
    },
    closeEdit() {
      this.resetData();
      this.editDialog = false;
    },
    confirmDelete(id, name, towers, batches) {
      if (towers !== 0 || batches !== 0) {
        this.$toasted.info(this.$vuetify.lang.translator("cannotDeleteLine"), {
          duration: 5000,
          keepOnHover: true,
          className:
            this.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return;
      }
      this.idToBeDeleted = id;
      this.dialogTitle = this.$vuetify.lang.translator(
        "sureToDeleteLine",
        name
      );
      this.deleteDialog = true;
    },
    tryDelete() {
      if (this.idToBeDeleted === 0) {
        this.$toasted.error(this.$vuetify.lang.translator("selectALine"), {
          duration: 5000,
          keepOnHover: true,
          className:
            self.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return;
      }
      this.waitForDelete = true;
      let self = this;
      self.$http
        .delete("/line/" + this.idToBeDeleted + "/")
        .then(() => {
          self.$toasted.success(self.$vuetify.lang.translator("lineDeleted"), {
            duration: 5000,
            keepOnHover: true,
            className:
              self.$store.getters.LANGUAGE == "fa"
                ? "vazir-font-fd"
                : "vazir-font",
            iconPack: "fontawesome",
            icon: "check",
            position: "top-center"
          });
          self.getLines();
          self.deleteDialog = false;
        })
        .catch(error => {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitForDelete = false;
        });
    },
    closeDelete() {
      this.idToBeDeleted = 0;
      this.deleteDialog = false;
    },
    updateMap() {
      setTimeout(() => {
        this.$refs.myMap.mapObject.invalidateSize();
      }, 100);
    },
    openMap(id, name, voltage) {
      var self = this;
      this.$http
        .get("/line/" + id + "/tower/list/")
        .then(function(response) {
          self.towers = [];
          self.latlangs = [];
          if (response.data.length === 0) {
            self.$toasted.error(self.$vuetify.lang.translator("noDataText"), {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          } else {
            for (let index = 0; index < response.data.length; index++) {
              let tower = response.data[index];
              self.towers.push({
                id: tower.id,
                name: tower.name,
                code: tower.code,
                position: [tower.lat, tower.lon],
                type1: 0,
                type2: 0,
                type3: 0
              });
              self.latlangs.push([tower.lat, tower.lon]);
              if (voltage <= 63) {
                self.lineColor = "blue";
              }
              if (voltage > 63 && voltage <= 132) {
                self.lineColor = "green";
              }
              if (voltage > 132 && voltage <= 230) {
                self.lineColor = "red";
              }
              if (voltage > 230) {
                self.lineColor = "purple";
              }
            }
            self.center = latLng(self.latlangs[0][0], self.latlangs[0][1]);
            self.dialogTitle = self.$vuetify.lang.translator(
              "showLineTowers",
              name
            );
            self.getLineBatches(id);
            self.selectedLineBatch = null;
            self.mapDialog = true;
          }
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    getLineBatches(id) {
      this.waitForLineBatches = true;
      var self = this;
      this.$http
        .get("/line/" + id + "/batches/list/")
        .then(function(response) {
          self.lineBatchesItems = response.data;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitForLineBatches = false;
        });
    },
    getBatcheTowersErrors() {
      if (this.selectedLineBatch != null) {
        var self = this;
        this.$http
          .get("/batch/" + this.selectedLineBatch + "/towers/errors/")
          .then(function(response) {
            for (
              let statsindex = 0;
              statsindex < response.data.length;
              statsindex++
            ) {
              let stats = response.data[statsindex];
              for (
                let towerindex = 0;
                towerindex < self.towers.length;
                towerindex++
              ) {
                let tower = self.towers[towerindex];
                if (tower.id == stats.id) {
                  self.towers[towerindex].type1 = stats.type1;
                  self.towers[towerindex].type2 = stats.type2;
                  self.towers[towerindex].type3 = stats.type3;
                  break;
                }
              }
            }
          })
          .catch(function(error) {
            let result = handleError(
              error,
              self.$toasted,
              self.$router,
              self.$store
            );
            for (var item in result) {
              self.$toasted.error(result[item], {
                duration: 5000,
                keepOnHover: true,
                className:
                  self.$store.getters.LANGUAGE == "fa"
                    ? "vazir-font-fd"
                    : "vazir-font",
                iconPack: "fontawesome",
                icon: "exclamation-triangle",
                position: "top-center"
              });
            }
          });
      }
    },
    tryImport() {
      this.fileRules = [
        required(this.$vuetify.lang.translator("file"), this.$vuetify),
        maxFileSize(
          2097152,
          this.$vuetify.lang.translator("file"),
          this.$vuetify
        )
      ];
      let self = this;
      setTimeout(function() {
        if (self.$refs.importForm.validate()) {
          self.waitForImport = true;
          var formData = new FormData();
          formData.append("excel_file", self.excelFile);
          self.$http
            .post("/employer/" + self.employer_id + "/line/import/", formData, {
              headers: { "Content-Type": "multipart/form-data" },
              onUploadProgress: function(event) {
                self.uploadPercentage = Math.round(
                  (event.loaded * 100) / event.total
                );
              }
            })
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("fileUploadedLinesCreated"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getLines();
              self.importDialog = false;
              self.resetData();
            })
            .catch(error => {
              let result = handleError(error, self.$toasted, self.$router);
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForImport = false;
            });
        }
      });
    },
    closeImport() {
      this.resetData();
      this.importDialog = false;
    },
    downloadKMZ(id) {
      this.kmzID = id;
      this.downloadKmzPercentage = 0;
      let self = this;
      this.$http
        .get("/line/" + id + "/kmz/", {
          responseType: "blob",
          onDownloadProgress: function(event) {
            self.downloadKmzPercentage = Math.round(
              (event.loaded * 100) / event.total
            );
          }
        })
        .then(response => {
          var filename = "export";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          const blob = new Blob([response.data], {
            type: "application/vnd.google-earth.kmz"
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          URL.revokeObjectURL(link.href);
          self.$toasted.success(
            self.$vuetify.lang.translator("downloadStarted"),
            {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "check",
              position: "top-center"
            }
          );
        })
        .catch(error => {
          if (
            error.response &&
            /json$/gi.test(error.response.headers["content-type"]) &&
            error.response.status === 400
          ) {
            self.$toasted.error(self.$vuetify.lang.translator("fileNotExist"), {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          } else {
            let result = handleError(error, self.$toasted, self.$router);
            for (var item in result) {
              self.$toasted.error(result[item], {
                duration: 5000,
                keepOnHover: true,
                className:
                  self.$store.getters.LANGUAGE == "fa"
                    ? "vazir-font-fd"
                    : "vazir-font",
                iconPack: "fontawesome",
                icon: "exclamation-triangle",
                position: "top-center"
              });
            }
          }
        })
        .then(function() {
          self.kmzID = 0;
        });
    },
    getIconAnchor() {
      if (this.$store.getters.LANGUAGE == "fa") {
        return [-12, 45];
      } else {
        return [25, 45];
      }
    },
    getDateFormat() {
      if (this.$store.getters.LANGUAGE == "fa") {
        return "jYYYY/jM/jD";
      } else {
        return "YYYY/M/D";
      }
    },
    resetData() {
      this.nameRules = [];
      this.fiftyRules = [];
      this.requiredRule = [];
      this.fileRules = [];

      this.fields.employer = null;
      this.fields.name = "";
      this.fields.origin = "";
      this.fields.destination = "";
      this.fields.code = "";
      this.fields.one_circut = null;
      this.fields.two_circut = null;
      this.fields.four_circut = null;
      this.fields.six_circut = null;
      this.fields.eight_circut = null;
      this.fields.voltage_level = null;

      this.editFields.id = null;
      this.editFields.employer = null;
      this.editFields.name = "";
      this.editFields.origin = "";
      this.editFields.destination = "";
      this.editFields.code = "";
      this.editFields.one_circut = null;
      this.editFields.two_circut = null;
      this.editFields.four_circut = null;
      this.editFields.six_circut = null;
      this.editFields.eight_circut = null;
      this.editFields.voltage_level = null;

      this.excelFile = null;
      this.uploadPercentage = 0;

      this.created_at = null;
      this.updated_at = null;
    },
    updateRecordsPerPage(rowsPerPage) {
      this.$store.dispatch("saveRecordsPerPage", rowsPerPage);
    }
  }
};
</script>
